import { render, staticRenderFns } from "./groupedpromotions-list-lgp.vue?vue&type=template&id=a575223c&"
import script from "./groupedpromotions-list-lgp.vue?vue&type=script&lang=js&"
export * from "./groupedpromotions-list-lgp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports